export const SKELETON_COUNTS = {
  categoryTiles: 8,
  products: 8,
  indoorPlants: 4,
  blogTeaser: 3,
  blogList: 4,
  productThumbs: 4,
  productOptions: 3,
  partnerLogos: 4,
  promoBanners: 1,
  orders: 3,
  orderItems: 3,
  wishlist: 3,
  testimonials: 3,
  related: 5,
} as const

export type SkeletonProps = {
  className?: string
}

export type ButtonSpinnerProps = {
  label?: string
}

export type CountedSkeletonProps = {
  count?: number
}

export type ProductGridSkeletonProps = CountedSkeletonProps
